import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';
import { map, take, filter } from 'ramda';

import { formatDate } from 'lib/dateDisplay';
import { createSummaryTile } from '../containers/SummaryLoaderContainer';
import TileRow from './TileRow';

import { path } from 'routes/Documents/routes/OnlineRehabilitation';

import icon from '../assets/onlineRehabilitation.svg';

const predicate = d => d;

const View = ({ data, localeMessage }) => {
  return (
    <Grid fluid>
      {map(d => {
        /*
         * Documents are sorted by last commit date, so if this is bugged then need to adjust
         * sorting function in summaryconfig(server), or make new one here.
         * In theory there should only be one active rehab at a time.
         */
        const started = !!d.start;
        const cancelled = !!d.cancelled;
        const finished = !!d.finished;
        return (
          <div key={d.documentId}>
            <p style={{ marginBottom: '2rem' }}>{localeMessage('onlineRehabilitation.tile.text')}</p>
            <TileRow title={localeMessage('onlineRehabilitation.tile.status')}>
              <p className="bold">
                {cancelled
                  ? localeMessage('onlineRehabilitation.tile.status.cancelled')
                  : finished
                    ? localeMessage('onlineRehabilitation.tile.status.finished')
                    : started
                      ? localeMessage('onlineRehabilitation.tile.status.started')
                      : '-'}
              </p>
            </TileRow>
            <TileRow key={d._id} title={localeMessage('onlineRehabilitation.tile.date')}>
              <p className="bold">{formatDate(d.lastCommitTime)}</p>
            </TileRow>
          </div>
        );
      })(take(1, filter(predicate, data)))}
    </Grid>
  );
};

View.propTypes = {
  localeMessage: PropTypes.func.isRequired,
  data: PropTypes.array,
};

export default createSummaryTile(View, {
  module: 'onlineRehabilitation',
  localeId: 'onlineRehabilitation.title',
  routeTo: path,
  icon,
});
